import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import ThirdPartyServiceForm, {ThirdPartyServiceFormBody} from "../ThirdPartyServiceForm";
import {useTranslation} from "react-i18next";
import HTMLTextInput from "../../common/HTMLTextInput/HTMLTextInput";
import React from "react";
import UserServiceModel from "../../../models/user/UserServiceModel";
import Collapsable from "../../common/Collapsable/Collapsable";

const initialState = {
    type: ThirdPartyServiceModel.Type.INVESTIGATE,
    serviceName: '',
    enabled: true,
    description: '',
    whitelistedCertFingerprints: [],

    url: '',
    serviceUrl: '',

    authenticationScope: ThirdPartyServiceModel.AuthenticationScope.SERVICE,
    authenticationMethod: ThirdPartyServiceModel.AuthenticationMethod.OIDC_CLIENT_CREDENTIALS,
    authenticationServiceId: null
};
const allowedAuthenticationMethods = [
    ThirdPartyServiceModel.AuthenticationMethod.OIDC_CLIENT_CREDENTIALS
];

function InvestigateServiceForm() {
    return (
        <ThirdPartyServiceForm initialState={initialState} FormBody={InvestigateServiceFormBody}/>
    )
}

export function InvestigateServiceFormBody(props) {
    return (
        <ThirdPartyServiceFormBody {...props} authenticationServiceType={UserServiceModel.types.OIDC} FormBody={FormBody}
            allowedAuthenticationMethods={allowedAuthenticationMethods}/>
    )
}

function FormBody(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        inputHandler,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.InvestigateSettings')} isDisabled={isDisabled}>
            <div className="display-input">
                <HTMLTextInput label={t('thirdPartyService:label.url')} name={'url'}
                               value={thirdPartyService.url} onChange={inputHandler} isDisabled={isDisabled}
                               isRequired/>
            </div>
            <div className="display-input">
                <HTMLTextInput label={t('thirdPartyService:label.serviceUrl')} name={'serviceUrl'}
                               value={thirdPartyService.serviceUrl} onChange={inputHandler} isDisabled={isDisabled}/>
            </div>
        </Collapsable>
    )
}

export default InvestigateServiceForm;
